import { combineReducers } from 'redux';
import type { Action } from 'state/actions';

import { tradesCancellationsReducer } from './cancellations/cancellations.reducer';
import type { TradesState } from './trades.models';

export const tradesReducer = combineReducers<TradesState, Action>({
  cancellations: tradesCancellationsReducer,
});
